<div class="flex gap-2 p-2">
	<button
		type="button"
		class="flex h-10 w-full items-center justify-center gap-1.5 rounded-[12px] border border-accentColor bg-white px-4 text-sm font-semibold uppercase tracking-wide text-accentColor"
		(click)="clearAllFilters()"
	>
		Wyczyść
	</button>
	<button
		type="button"
		class="flex h-10 w-full items-center justify-center gap-1.5 rounded-[12px] border border-accentColor bg-accentColor px-4 text-sm font-semibold uppercase tracking-wide text-white transition-colors hover:bg-accentHoverColor"
		(click)="closeDialog()"
	>
		Pokaż oferty
	</button>
</div>
